/**
 * @generated SignedSource<<e2aeafe7fcb6619114848744a3dc17ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GraphQLJobRunStatus = "COMPLETED" | "ERRORED" | "IN_PROGRESS" | "PENDING" | "STOPPED" | "%future added value";
export type GraphQLJobTaskType = "AGENT" | "AGENT_DASHBOARD_SNAPSHOT" | "ALERT_INSIGHTS" | "ALERT_RESPONDER" | "ALERT_THREAD_LEARNING" | "AWS_MARKETPLACE_METERING" | "BITBUCKET_TOKEN_REFRESH" | "BUILDKITE_SYNC" | "CODE_PULL" | "CREDITS_COMPUTATION_V2" | "CTA_REMINDER" | "CUSTOMER_AGENT_IMAGE_BUILD" | "CUSTOMER_AGENT_SANDBOX_IMAGE_CACHE" | "CUSTOM_MCP_SERVER_TOOL_REFRESH" | "DAG_AGENT" | "DATABRICKS_MEMORY_INGESTION" | "DATABRICKS_SYNC" | "DATABRICKS_TO_POSTGRES_SYNC" | "DIGEST" | "GENERIC_LEARNING" | "GITHUB_CODEBASE_ANALYSIS" | "GITLAB_TOKEN_REFRESH" | "GRAFANA_CLOUD_DATASOURCE_SYNC" | "INCIDENT_CHANNEL_LEARNING" | "INCIDENT_DAG_AGENT" | "INCIDENT_KNOWLEDGE_SYNC" | "INGEST_SLACK_CHANNEL" | "NEWRELIC_APPLICATION_SYNC" | "ONBOARDING" | "ONBOARDING_QUESTION_TRAINING" | "PRODUCT_ANALYTICS" | "RESOURCE_FILES_SYNC" | "RESOURCE_SYNC_QUEUE" | "SLACK_CACHE_REFRESH" | "SLACK_USERGROUP_REFRESH" | "SNAPSHOT_CLEANUP" | "SUPPORT_AGENT_METRIC_CALCULATOR" | "SUPPORT_INSTRUCTION_GENERATION" | "TEAM_INSTRUCTION_GENERATION" | "WHAT_TIME_IS_IT_RIGHT_NOW" | "WORKFLOW_INVESTIGATION" | "WORKFLOW_MEMORY_CONSOLIDATION" | "WORKFLOW_MEMORY_EVAL_RECONCILER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type JobRunDetails_jobRun$data = {
  readonly createdAt: any;
  readonly id: any;
  readonly investigation: {
    readonly id: any;
    readonly summary: string;
  } | null | undefined;
  readonly job: {
    readonly id: any;
    readonly name: string;
    readonly taskType: GraphQLJobTaskType;
  };
  readonly name: string;
  readonly status: GraphQLJobRunStatus;
  readonly updatedAt: any;
  readonly " $fragmentSpreads": FragmentRefs<"JobRunHeader_jobRun" | "JobRunOutput_jobRun">;
  readonly " $fragmentType": "JobRunDetails_jobRun";
};
export type JobRunDetails_jobRun$key = {
  readonly " $data"?: JobRunDetails_jobRun$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobRunDetails_jobRun">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobRunDetails_jobRun",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLJob",
      "kind": "LinkedField",
      "name": "job",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLInvestigation",
      "kind": "LinkedField",
      "name": "investigation",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobRunHeader_jobRun"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobRunOutput_jobRun"
    }
  ],
  "type": "GraphQLJobRun",
  "abstractKey": null
};
})();

(node as any).hash = "3b94265e545f4d38c1c173759dd70f8f";

export default node;
